import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { useCloseTimeout, useNotification, useUkTimeZone } from '../../../hooks'
import Button from '../../Button'
import { Checkbox, CHECKBOX_SIZE } from '../../Checkbox'
import { ClampingText } from '../../ClampingText'
import Text from '../../Text'
import { getCreationTime } from '../Notification.utils'
import { NotificationIcon } from '../NotificationIcon'
import { NotificationLink } from '../NotificationLink'
import { NotificationTextButton } from '../NotificationTextButton'

import {
  NOTIFICATION_DEFAULT_TIMEOUT,
  NOTIFICATION_DEFAULT_TYPE,
} from './Notification.constants'

import * as styles from './Notification.module.css'

import Close from '../../../icons/close.svg'

// #TODO
// Rework with `children` prop, to show all content via children all get rid of `flags`
function Notification(props) {
  const {
    checkbox,
    checkboxProps,
    children,
    className,
    creationDate,
    id,
    linkProps,
    text,
    textButtonValue,
    timeout = NOTIFICATION_DEFAULT_TIMEOUT,
    title,
    type = NOTIFICATION_DEFAULT_TYPE,
    withCloseButton,
  } = props

  const { t } = useTranslation()

  const { timezone } = useUkTimeZone()

  const { handleRemoveNotification } = useNotification()

  const [checkboxValue, setCheckboxValue] = useState(false)

  function handleClose() {
    handleRemoveNotification(id)
  }

  const { handleClearCloseTimeout, handleSetCloseTimeout } = useCloseTimeout({
    timeout,
    onClose: handleClose,
  })

  useEffect(() => {
    if (timeout) {
      handleSetCloseTimeout()

      return function cleanup() {
        handleSetCloseTimeout()
      }
    }
  }, [timeout])

  const notificationClassName = classNames(
    styles.notification,
    styles[type],
    className
  )

  function handleChangeCheckbox() {
    checkboxProps.onChange?.(!checkboxValue)
    setCheckboxValue(v => !v)
  }

  return (
    <div
      className={notificationClassName}
      onMouseEnter={handleClearCloseTimeout}
      onMouseLeave={handleSetCloseTimeout}
    >
      <NotificationIcon className={styles.icon} type={type} />

      <div className={styles.content}>
        <span className={styles.title}>{title}</span>
        {text ? (
          <ClampingText fullText={text} textClassName={styles.text} />
        ) : null}
        {children}
        {linkProps ? (
          <NotificationLink {...linkProps} className={styles.link} />
        ) : null}
        {textButtonValue ? (
          <NotificationTextButton
            className={styles.textButton}
            text={textButtonValue}
            onClick={props.onClickTextButton}
          />
        ) : null}
        {checkbox ? (
          <Checkbox
            {...checkboxProps}
            checked={checkboxValue}
            className={styles.checkbox}
            size={CHECKBOX_SIZE.small}
            onChange={handleChangeCheckbox}
          />
        ) : null}
        {creationDate ? (
          <Text isSecondary className={styles.creationTime}>
            {getCreationTime(creationDate, timezone)}
          </Text>
        ) : null}
      </div>

      {withCloseButton ? (
        <Button.Icon
          isGrey
          Icon={Close}
          tooltip={t('Notification.TooltipCloseBtn')}
          onClick={handleClose}
        />
      ) : null}
    </div>
  )
}

export default Notification
